import { BRANCH_SHAREABLE } from '../actions/ShareableActions';

export class ShareableLocalStorageService {
  static calculateLocalStorageUsage() {
    let totalBytes = 0;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const value = key ? (localStorage.getItem(key) ?? '') : '';
      totalBytes += this.getByteLength(key!) + this.getByteLength(value);
    }

    return {
      bytes: totalBytes,
      kilobytes: +(totalBytes / 1024).toFixed(2),
      megabytes: +(totalBytes / (1024 * 1024)).toFixed(2),
    };
  }

  static writeShareableState(state: Record<string, any>) {
    localStorage.setItem(BRANCH_SHAREABLE, JSON.stringify(state));
  }

  static purgeExceptEntity(state: Record<string, any>, entityId: string) {
    return state[entityId] ? { [entityId]: state[entityId] } : {};
  }

  private static getByteLength(s: string): number {
    if (typeof TextEncoder !== 'undefined') {
      const encoder = new TextEncoder();
      return encoder.encode(s).length;
    } else if (typeof Blob !== 'undefined') {
      return new Blob([s]).size;
    } else {
      return s.length;
    }
  }
}
